import { useEffect } from 'react';
import { useErrorBoundary } from 'use-error-boundary';

const RenderErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { ErrorBoundary, error, reset } = useErrorBoundary();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    if (error) {
      console.error(error);
      reset();
    }
  }, [error]);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default RenderErrorBoundary;
